/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-27 20:41:39
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-06 13:24:08
 * @FilePath: /unifyxp-v2-store-portal/src/request/common/index.ts
 */
import { post, get } from 'src/tools/server';
import { Image } from 'src/types/common/common';
import { IWarehouse } from 'src/types/common/warehouse';

const editImage = (uuid, body): Promise<Image> => {
  const form_data = new FormData();
  for (const key in body) {
    form_data.append(key, body[key]);
  }
  return post<Image>(`portal/image/edit/${uuid}`, form_data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const getSalesChannelStyle = (body) => {
  return post<any>(`/portal/salesChannel/siteStyles`, body, {});
};

const checkSlug = (
  url: string,
  body,
): Promise<{
  payload: boolean;
}> => {
  return post<{
    payload: boolean;
  }>(url, body, {});
};

const checkSalesChannelSiderErr = ({ salesChannelUuid }): Promise<any> => {
  return get<any>(
    `/portal/salesChannel/${salesChannelUuid}/sidebar`,

    {},
  );
};

const checkSalesChannelContentSiderErr = (uuids, params): Promise<any> => {
  const { salesChannelUuid, contentUuid } = uuids;

  return get<any>(
    `/portal/salesChannel/${salesChannelUuid}/sidebar/content/${contentUuid}`,
    params || {},
  );
};

const checkSalesChannelProductSiderErr = (uuids, params): Promise<any> => {
  const {
    salesChannelUuid, //productUuid
  } = uuids;
  return get<any>(
    `/portal/salesChannel/${salesChannelUuid}/sidebar/products`,
    params || {},
  );
};

const asyncGetPlainText = (text) => {
  return post(`/portal/utils/html/getPlainText`, text, {
    headers: { 'Content-Type': 'text/html' },
  });
};

export const getAllLanguage = () => {
  return get<any>(`/portal/languages`, {});
};

const getCustomerInfoFields = (uuid) => {
  return get(`/portal/customerDatabase/fields/${uuid}`, {});
};

const getActiveWarehouse = (): Promise<IWarehouse[]> => {
  return get(`/portal/setting/store/logistics/activatedWarehouses`, {});
};

const cameraPhotoUploaded = (data) => {
  return post(`/portal/mediaLibrary/upload?type=Parcel`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

const getAreaCode = () => {
  return get(`/portal/areaCodeMap`, {});
};

const getBasicSetting = () => {
  return get(`/portal/basic/storeSetting`, {});
};
const getAreaCodeAll = () => {
  return get<any>('/portal/areaCodes', {});
};
const getCountries = () => {
  return get<any>('/portal/countries', {});
};

const portalLogin = (data) => {
  return post<any>('/config/sso/token/validate', data, { isGuest: true });
};

const loginDomain = () => {
  return get<any>('/config/loginDomain', { isGuest: true });
};

const getAllTemplates = (category, salesChannelUuid) => {
  return post<any>(
    '/portal/communication/templates',
    { category, salesChannelUuid },
    {},
  );
};

export {
  editImage,
  checkSlug,
  checkSalesChannelSiderErr,
  checkSalesChannelContentSiderErr,
  checkSalesChannelProductSiderErr,
  asyncGetPlainText,
  getCustomerInfoFields,
  getActiveWarehouse,
  cameraPhotoUploaded,
  getSalesChannelStyle,
  getAreaCode,
  getBasicSetting,
  getAreaCodeAll,
  getCountries,
  portalLogin,
  getAllTemplates,
  loginDomain,
};
